import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Testids } from '@mono/ui-selectors';
import { ArrowLeft, Lock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { PageEmptyState } from '../layout';
import { RequestAccessPanel } from './RequestAccessPanel';
export function ProgramAccessGate({ programId, title = "You don't have access to this program", description = 'Request access below and a reviewer will be notified, or ask your administrator to add you to the program roster.', backHref = '/delivery/programs', backLabel = 'Back to Programs' }) {
    const navigate = useNavigate();
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": Testids.deliveryPrograms.noAccessScreen,
        children: [
            /*#__PURE__*/ _jsx(PageEmptyState, {
                icon: /*#__PURE__*/ _jsx(Lock, {}),
                title: title,
                description: description,
                action: {
                    label: backLabel,
                    icon: /*#__PURE__*/ _jsx(ArrowLeft, {
                        className: "w-4 h-4 mr-2"
                    }),
                    onClick: ()=>navigate(backHref),
                    dataTestid: Testids.deliveryPrograms.noAccessBack
                },
                size: "lg"
            }),
            /*#__PURE__*/ _jsx(RequestAccessPanel, {
                targetObjectType: "delivery.programs",
                targetObjectId: programId
            })
        ]
    });
}
